__webpack_require__.p = "https://bpmrat-dev.bpglobal.com/";